<script>
export let constructorId;

import {apiUrl} from '../config.svelte';
import { Table,Button, Input, Card,CardBody,Label} from 'sveltestrap';
import {onMount,onDestroy} from 'svelte';
import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();
/* main constructor variables */
let schema={}
let objections=[]
let elems=[]
let files;
let phones=[]
let activity =undefined;

/*common constructor variables*/
let elemSize = 60;
let shift = 62;
let archiveNodes=[]

let underMouseElem=undefined;
let chosenElem = undefined;
let objectionShown = false;
let filterShown = false;
let filterArea = "";
let filterFilter = "";
let newFilter ="";
let newObj={name:"",filter:[]}


let chosenArchiveNode = undefined;
let filterArchiveNodeArea=""
let filterArchiveNodeShown = false;
let objectionArchiveNodeShown = false;
let filterArchiveNodeFilter = "";
let newArchiveNodeFilter ="";
let newArchiveNodeObj={name:"",filter:[]}

/*show hide flags */


let objectionListShown=false;
let audioListShown=false;
let archiveNodesShown=false;

let pickFromArchive;

let uploadingFiles;
let chosenObjection = undefined;
let filterObjectionArea = ""
let filterObjectionFilter = ""
let newObjectionFilter =""
let player ;
let files_dir = "/audio/"
let synSpeech ={
    text:"",
    filename:"",
    voice:"zahar",
    speed:1.2,
}
onMount(()=>{
    //console.log('uploading',uploadingFiles)
    schema={}
    objections=[]
    fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"constructor",id:constructorId}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
           if(x.result){
               loadArchiveNodes()
               activity = x.data.activity; 
               console.log('x.result',x)        
               console.log('activity',activity)        
               let c = JSON.parse(x.data.jsn)
               schema = c.schema

               objections=c.objections
               files=x.data.files
               //console.log(JSON.stringify(schema))
               let tmpO = itterate(schema)
               console.log(tmpO)
               elems=tmpO.obj
               //elems.forEach(c=>console.log(c.name,c.x))
           }
        })
        .catch((e)=>{

        })
})
function loadArchiveNodes(){
    archiveNodes=[]
    fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"archive-nodes"}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
           if(x.result){
               x.data.forEach(d=>{
                   console.log(x.data)
                   archiveNodes.push(JSON.parse(d.jsn))
               })
               
               //elems.forEach(c=>console.log(c.name,c.x))
           }
        })
        .catch((e)=>{

        })
}
function restoreFromArchive(){
    let pick;
    archiveNodes.forEach(a=>{
        if(a.name==chosenElem.name){
            pick=a;
        }
    })
    if(pick)
        pickArchive(pick)
}
function pickArchive(pick){
    chosenElem.type=pick.type
    chosenElem.name=pick.name
    chosenElem.action=pick.action
    chosenElem.nerType=pick.nerType
    chosenElem.filter=pick.filter
    chosenElem.file=pick.file
    chosenElem.objection=pick.objection
    chosenElem.text=pick.text
    chosenElem.speed=pick.speed
    chosenElem.voice=pick.voice
    chosenElem.number=pick.number
    chosenElem.archiveNode = pick.name
    //chosenElem.children=[]
    chosenElem=chosenElem
}
function removeArchiveNode(node){
    name=  node.name
    fetch(apiUrl+"ivm",{
        credentials: "include",
        method:"POST",
        body:JSON.stringify({method:"remove-archive-node",name:name}),
        cors:'no-cors'
    })
    .then(x=>x.json())
    .then(x=>{
        if(x.result){
            archiveNodes.splice(archiveNodes.indexOf(node),1);
            archiveNodes=archiveNodes
            chosenArchiveNode=undefined

        }else{
            alert("ошибка.")
        }
    })
    .catch((e)=>{
        alert("ошибка сервера")
    })
}
function updateArchive(node){
    let nd = {
        type:node.type,
        name:node.name,
        action:node.action,
        nerType:node.nerType,
        filter:node.filter,
        file:node.file,
        objection:node.objection,
        text:node.text,
        speed:node.speed,
        voice:node.voice,
        number:node.number,
        children:[]
    }
    fetch(apiUrl+"ivm",{
        credentials: "include",
        method:"POST",
        body:JSON.stringify({method:"update-archive-node",node:nd}),
        cors:'no-cors'
    })
    .then(x=>x.json())
    .then(x=>{
        if(x.result){
            node.achiveNode=node.name
            chosenElem=chosenElem
            archiveNodes.forEach(a=>{
                if(node.name==a.name){
                    a.type=node.type
                    a.name=node.name
                    a.action=node.action
                    a.nerType=node.nerType
                    a.filter=node.filter
                    a.file=node.file
                    a.objection=node.objection
                    a.text=node.text
                    a.speed=node.speed
                    a.voice=node.voice
                    a.number=node.number
                }
            })
            archiveNodes=archiveNodes
        }else{
            alert("ошибка.")
        }
    })
    .catch((e)=>{
        alert("ошибка сервера")
    })
}
function saveAsArchive(node){
    let nd = {
        type:node.type,
        name:node.name,
        action:node.action,
        nerType:node.nerType,
        filter:node.filter,
        file:node.file,
        objection:node.objection,
        text:node.text,
        speed:node.speed,
        voice:node.voice,
        number:node.number,
        children:[]
    }
    fetch(apiUrl+"ivm",{
        credentials: "include",
        method:"POST",
        body:JSON.stringify({method:"add-archive-node",node:nd}),
        cors:'no-cors'
    })
    .then(x=>x.json())
    .then(x=>{
        if(x.result){
            node.achiveNode=node.name
            chosenElem=chosenElem
            archiveNodes.push(nd)
        }else{
            alert("ошибка. возможно имя занято.")
        }
    })
    .catch((e)=>{
        alert("ошибка сервера")
    })
}
function itterate(el,y=0,parent=null){
    
    if ( typeof el.filter=='string' ){
        if (el.filter!="")
            el.filter = el.filter.split('|')
        else
            el.filter = []
    }
    if ( typeof el.objection=='string' ){
        if (el.objection!="")
            el.objection = el.objection.split('|')
        else
            el.objection = []
    }
    if(parent==null){
        phones=[]
    }
    if(el.number){
        phones.push(el.number)
    }
    let schemaEl ={
        name:el.name,
        type:el.type,
        action:el.action,
        nerType:el.nerType,
        filter:el.filter,
        file:el.file,
        objection:el.objection,
        text:el.text,
        speed:el.speed,
        voice:el.voice,
        number:el.number,
        children:[]
    }
    let arr=[el,]
    let childrenCount=0
    if(el.children){
        el.children.forEach(x=>{
            x.parent=el;
            let tempO=itterate(x,y+1,el)
            tempO.obj.forEach(e => {
                if(e.y==y+1)
                    childrenCount +=e.childrenCount==0?1:e.childrenCount;
                arr.push(e)
            });
            schemaEl.children.push(tempO.schema)
        })
    }
    el.childrenCount=childrenCount;//el.children.length;
    el.y=y;
    let i=0;
    arr.forEach(x=>{
        x.x=i;
        if(x.childrenCount==0)
            i++;
    })
    return {obj:arr,schema:schemaEl};
}
function appendChild(el){
    el.children.push({
        name:"",
        action:"",
        type:"",
        filter:"",
        objection:[],
        number:"",
        file:"",
        voice:'oksana',
        speed:1.0,
        text:'',
        nerType:"any",
        children:[],
    })
    elems=itterate(schema).obj
}
function insertChild(el){
    if(el.parent)
    {
        let indx = el.parent.children.indexOf(el)
        let new_el={
            name:"",
            action:"",
            type:"",
            file:"",
            filter:"",
            objection:[],
            number:"",
            voice:'oksana',
            speed:1.0,
            text:'',
            nerType:"any",
            children:[],
        }
        el.parent.children.splice(indx+1,0,new_el);
    }
    
    elems=itterate(schema).obj
}
function removeElementTree(el){
    if(el.parent!=null)
        el.parent.children.splice(el.parent.children.indexOf(el),1);
    elems=itterate(schema).obj
}
function sendFileBinary(){
    let fs =[...uploadingFiles];
    let farray = []
    fs.forEach(x=>{
        let fname = x.name;
        var reader = new FileReader();
        var fileByteArray = [];
        reader.readAsArrayBuffer(x);
        reader.onloadend = function (evt) {
            if (evt.target.readyState == FileReader.DONE) {
                var arrayBuffer = evt.target.result,
                    array = new Uint8Array(arrayBuffer);
                for (var i = 0; i < array.length; i++) {
                    fileByteArray.push(array[i]);
                    }
            }
            console.log(fname,fileByteArray);
            farray.push({name:fname,data:fileByteArray})
        }
    })
    fetch(apiUrl+"ivm",{
       credentials: "include",
        method:"POST",
        cors:'no-cors',
        body:JSON.stringify({
            method:"upload-file",
            activity:activity,
            files:farray
        })
        .then(x=>x.json())
        .then(x=>{
            if (x.result){
                farray.forEach(x=>{
                    files.push(x.name)
                })
            }else{
                alert("ошибка загрузки")
            }
        })
        .catch(()=>{
            alert("ошибка загрузки")
        })

    })

}
function close(){
    dispatch('close',{})
}
function save(){
    let tempO = itterate(schema)
    let result={
        schema:tempO.schema,
        objections:objections,
        phones:phones
    }
    console.log(result)
    fetch(apiUrl+"ivm",{
       credentials: "include",
        method:"POST",
        cors:'no-cors',
        body:JSON.stringify({
            method:"save-constructor",
            id:constructorId,
            schema:result
        })
    })
    .then(x=>x.json())
    .then(x=>{
        if (x.result){
            alert("Сохранено")
        }else{
            alert("ошибка сохранения")
        }
    })
    .catch(()=>{

        alert("ошибка сохранения")
    })
}

function text_to_wav(){
    let allSuccess=true;
    let troubles="";
    if(!(synSpeech.text && synSpeech.text.trim()!="")){
        allSuccess=false
        troubles+="не указан текст\n"
    }
    if(!(synSpeech.filename&&synSpeech.filename.trim()!="")){
        allSuccess=false
        troubles+="не указано имя файла\n"
    }
    if(!(synSpeech.voice)){
        allSuccess=false
        troubles+="не указан голос\n"
    }
    if(!(synSpeech.speed)){
        allSuccess=false
        troubles+="не указана скорость\n"
    }
    if(synSpeech.filename.indexOf(".wav")==-1)
        synSpeech.filename=synSpeech.filename+".wav"
    if(files)
        files.forEach(f=>{
            if(f==synSpeech.filename){
                let b = window.confirm("файл уже существует перезаписать?")
                if(!b){
                    allSuccess=false;
                    troubles+="отказано в замене файла\n"
                }
            }
        })
    if(allSuccess){
        console.log(activity)
        synSpeech.activity=activity
        synSpeech.method="text-to-wav"
        fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            cors:'no-cors',
            body:JSON.stringify(synSpeech)
        })
        .then(x=>x.json())
        .then(x=>{
            if (x.result){
                files.push(synSpeech.filename)
                files=files;
            }else{
                alert("ошибка синтеза")
            }
        })
        .catch(()=>{
            alert("ошибка синтеза")
        })
    }else{
        alert(troubles)
    }
}
function chooseElem(elem){
    console.log(elem)
    archiveNodes.forEach(a=>{
        if(elem.name==a.name){
            elem.archiveNode=a.name
        }
    })
    chosenElem=elem;filterShown=false;objectionShown=false
}
function chooseArchiveElem(elem){
    chosenArchiveNode=elem;
}

</script>
<style>
    td{
        padding:1px;
    }
    div.elem-box{
        position:absolute;
        
        margin:0px;
        box-shadow:0px 0px 2px grey;
        background-color: white;
    }
    div.archive-elem-box{
        margin:0px;
        box-shadow:0px 0px 2px grey;
        background-color: white;
    }

    img.elem-type{
        
        width:42px;
        height:42px;
        margin:10px;
        cursor:pointer;
        border-radius: 20px 20px 20px 20px;
    }

    img.elem-action{
        position:absolute;
        top:2px;
        right:2px;
        width:23px;
        height:23px;
        z-index:101;
    }

    img.add-elem{
        position:absolute;
        height:30px;
        width:30px;
        z-index:102;
        cursor:pointer;
    }

</style>
<div style="position:absolute;width:calc(100% - 20px);height:calc(100% - 20px)"> 
    <div style="position:absolute;width:100%;height:40px;box-shadow:0px 0px 2px grey;">
        <Button outline color="dark" style="width:200px" on:click={()=>{ audioListShown=true;archiveNodesShown=false} }>Аудио файлы</Button>
        <Button outline color="dark" style="width:200px" on:click={()=>{ archiveNodesShown=true;audioListShown=false} }>Коллекции</Button>
        
        <Button outline color="success" style="width:200px;margin-left:100px;" on:click={()=>{ save() } }>Сохранить</Button>
        <Button outline color="dark" style="width:200px;margin-left:30px;" on:click={()=>{ close() } }>Закрыть</Button>

    </div>
    {#if audioListShown}
        <div style="position:absolute;width:460px;height:calc(100% - 40px);top:40px;margin:10px;overflow:auto;z-index:100">
            <audio bind:this={player} controls="controls" style='height:30px;'>
            </audio>
            
            <Table borderless size="sm" style="width:auto">
            <tr>
                <td><Input type="file" on:change={(e)=>{console.log(e.target.files);uploadingFiles=e.target.files}}/></td>
                <td><Button outline color="success" on:click={()=>{sendFileBinary() }}>Загрузить</Button></td>
            </tr>
            {#each files as file}
                <tr>
                    <td>{file}</td>
                    <td><Button outline color="success" on:click={()=>{player.src=files_dir+activity+"/"+file;player.load();player.play()}}>play</Button></td>
                    <!--<td><Button outline color="danger">Удалить</Button></td> -->
                </tr>
            {/each}
            </Table>
        </div>
        
        <div style="position:absolute;width:50%;height:50px;left:480px;top:40px;">
            <div style="width:100%;height:50px;left:0px;top:0px;">
                <Button outline color="dark" style="float:right;width:120px" on:click={()=>{audioListShown=false}}>Закрыть</Button>
            </div>
            <div>
                <h3>Синтез речи:</h3>
                <Label>текст</Label>
                <Input type="textarea" bind:value={synSpeech.text} />
                <Label>название файла</Label>
                <Input type="text" bind:value={synSpeech.filename} placeholder="название файла"/>
                <Label>скорость</Label>
                <Input type="number" bind:value={synSpeech.speed} placeholder="скорость" />
                <Label>голос</Label>
                <Input type="select" bind:value={synSpeech.voice} >
                    <option value={undefined}>голос</option>
                    <option value="zahar">Захар</option>
                    <option value="oksana">Оксана</option>
                    <option value="jane">Джейн</option>
                    <option value="omazh">Омаж</option>
                    <option value="ermil">Ермил</option>
                </Input>
                <Button outline color="success" style="float:right" on:click={()=>{text_to_wav()}}>Синтезировать</Button>
            </div>
        </div>
    {:else if archiveNodesShown}
        <div style="position:absolute;width:100%;height:calc(100% - 40px);top:40px;margin:10px;overflow:auto;z-index:100">
            <div style="width:100%;height:42px">
                <Button color="dark" outline on:click={()=>{archiveNodesShown=false}}>Закрыть</Button>
            </div>
            {#each archiveNodes as elem}
                <div class="archive-elem-box" style={`position:relative;width:${elemSize}px;height:${elemSize}px;float:left;`} title={elem.name} on:click={()=>{chooseArchiveElem(elem)}}>
                    {#if elem.type=="start"}
                        <img class="elem-type" src="/img/start.png" alt="start"/>
                    {:else if elem.type=="agree"}
                        <img class="elem-type" src="/img/agree.png" alt="agree" style="background-color:rgb(199, 252, 189)"/>
                    {:else if elem.type=="deny"}
                        <img class="elem-type" src="/img/deny.png" alt="deny" style="background-color:rgb(252, 189, 189)"/>
                    {:else if elem.type=="any"}
                        <img class="elem-type" src="/img/any.png" alt="any" style="background-color:rgb(191, 245, 252)"/>
                    {:else if elem.type=="objection"}
                        <img class="elem-type" src="/img/objection.png" alt="objection" style="background-color:rgb(252, 235, 189)"/>
                     {:else if elem.type=="other"}
                        <img class="elem-type" src="/img/other.png" alt="other" style="background-color:rgb(199, 251, 255);"/>
                    {:else}
                        <img class="elem-type" src="/img/new.png" alt="new" style="background-color:white"/>
                   
                    {/if}
                    {#if elem.action}
                        {#if elem.action=="play"}
                            <img src="/img/play.png" class="elem-action" alt="play" />
                        {:else if elem.action=="hangup"}
                            <img src="/img/hangup.png" class="elem-action" alt="hangup" />
                        {:else if elem.action=="transfer"}
                            <img src="/img/transfer.png" class="elem-action" alt="transfer" />
                        {:else if elem.action=="synthes"}
                            <img src="/img/synthes.png" class="elem-action" alt="synthes" />
                        {:else if elem.action=="ner"}
                            <img src="/img/ner.png" class="elem-action" alt="ner" />
                        
                        {/if}
                    {/if}
                </div>
                
            {/each}
            {#if chosenArchiveNode}
                    <Card style="width:500px;height:450px;postition:absolute;z-index:104;top:50px;left:50px;overflow:auto">
                        <CardBody>
                            {#if !filterArchiveNodeShown && !objectionArchiveNodeShown}
                                <div style="width:100%;height:50px">
                                    
                                    <Button outline color="dark" style="float:right;width:120px" on:click={()=>{chosenArchiveNode=undefined}}>Закрыть</Button>
                                </div>
                                <Table size="sm" borderless>
                                    <tbody>
                                        <tr><td><Label style="float:right;margin-top:6px;margin-bottom:0px">название</Label></td><td><Input type="text" bind:value={chosenArchiveNode.name} /></td></tr>
                                        <tr>
                                            <td><Label style="float:right;margin-top:6px;margin-bottom:0px">тип варианта</Label></td>
                                            <td>
                                                <Input type="select" bind:value={chosenArchiveNode.type} >
                                                    <option value=""></option>
                                                    <option value="agree">согласие</option>
                                                    <option value="deny">отказ</option>
                                                    <option value="any">любой</option>
                                                    <option value="objection">возражение</option>
                                                    <option value="other">другое</option>
                                                </Input>
                                            </td>
                                        </tr>
                                        {#if chosenArchiveNode.type=="agree" || chosenArchiveNode.type=="deny"}
                                            <tr>
                                                <td><Label style="float:right;margin-top:6px;margin-bottom:0px">фильтр</Label></td>
                                                <td><Button outline color="dark" on:click={()=>{filterArchiveNodeShown=true}} >открыть...</Button></td>
                                            </tr>
                                        {/if}
                                        {#if chosenArchiveNode.type!='objection'}
                                            <tr>
                                                <td><Label style="float:right;margin-top:6px;margin-bottom:0px">действие</Label></td>
                                                <td>
                                                    <Input type="select" bind:value={chosenArchiveNode.action}>
                                                        <option value=""></option>
                                                        <option value="play">воспроизвести</option>
                                                        <option value="hangup">бросить трубку</option>
                                                        <option value="transfer">перевести на номер</option>
                                                        <option value="synthes">речь из текста</option>
                                                        <option value="ner">распознать информацию</option>
                                                    </Input>
                                                </td>
                                            </tr>
                                        {/if}
                                        {#if chosenArchiveNode.action == "ner"}
                                            <tr>
                                                <td><Label style="float:right;margin-top:6px;margin-bottom:0px">тип информации</Label></td>
                                                <td>
                                                    <Input type="select" bind:value={chosenArchiveNode.nerType}>
                                                        <option value="any">любая информация</option>
                                                        <option value="address">адрес</option>
                                                        <option value="phone">номер телефона</option>
                                                        <option value="date">дата</option>
                                                        <option value="fio">ФИО</option>
                                                    </Input>
                                                </td>
                                            </tr>
                                        {/if}
                                        {#if chosenArchiveNode.action == "synthes"}
                                            <tr>
                                                <td><Label style="float:right;margin-top:6px;margin-bottom:0px">текст</Label></td>
                                                <td>
                                                    <Input type="textarea" bind:value={chosenArchiveNode.text}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><Label style="float:right;margin-top:6px;margin-bottom:0px">голос</Label></td>
                                                <td>
                                                    <Input type="select" bind:value={chosenArchiveNode.voice}>
                                                        <option value="zahar">Захар</option>
                                                        <option value="oksana">Оксана</option>
                                                        <option value="jane">Джейн</option>
                                                        <option value="omazh">Омаж</option>
                                                        <option value="ermil">Ермил</option>
                                                    </Input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><Label style="float:right;margin-top:6px;margin-bottom:0px">скорость</Label></td>
                                                <td>
                                                    <Input type="number" bind:value={chosenArchiveNode.speed}/>
                                                </td>
                                            </tr>
                                        {/if}
                                        {#if chosenArchiveNode.action == "play"}
                                            <tr>
                                                <td><Label style="float:right;margin-top:6px;margin-bottom:0px">файл</Label></td>
                                                <td>
                                                    <Input type="select" bind:value={chosenArchiveNode.file}>
                                                        <option value=""></option>
                                                        {#each files as file}
                                                            <option>{file}</option>
                                                        {/each}
                                                    </Input>
                                                </td>
                                            </tr>
                                        {/if}
                                        {#if chosenArchiveNode.action=="transfer"}
                                            <tr><td><Label style="float:right;margin-top:6px;margin-bottom:0px">номер</Label></td><td><Input type="text" bind:value={chosenArchiveNode.number} /></td></tr>
                                        {/if}
                                        <!--{#if chosenArchiveNode.type=="objection" }
                                            <tr>
                                                <td><Label style="float:right;margin-top:6px;margin-bottom:0px">возражения</Label></td>
                                                <td><Button outline color="dark" on:click={()=>{objectionShown=true}} >открыть...</Button></td>
                                            </tr>
                                        {/if}
                                        -->
                                    </tbody>
                                </Table>
                                    <Button outline color="danger"style="position:absolute;bottom:3px;right:3px;" on:click={()=>{removeArchiveNode(chosenArchiveNode);}}>❌ удалить узел</Button>

                            {:else if filterArchiveNodeShown}
                                <div style="width:100%;height:50px">
                                    <Button outline color="dark" style="float:right;width:120px" on:click={()=>{filterArchiveNodeShown=false}}>Закрыть</Button>
                                </div>
                                <Table size="sm" borderless>
                                    <tr>
                                        <td>
                                            <Input type="textarea" bind:value={filterArchiveNodeArea} />
                                        </td>
                                        <td>
                                            <Button outline color="dark" on:click={()=>{ chosenArchiveNode.filter=filterArchiveNodeArea.split('\n');filterArchiveNodeArea=""}}>разобрать</Button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><Input typoe="text" bind:value={filterArchiveNodeFilter} placeholder="поиск..." /></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Input type="text" bind:value={newArchiveNodeFilter} />
                                        </td>
                                        <td>
                                            <Button outline color="success" on:click={()=>{ if(newArchiveNodeFilter.trim()!="")chosenArchiveNode.filter.splice(0,0,newArchiveNodeFilter.trim());newArchiveNodeFilter="";chosenArchiveNode.filter=chosenArchiveNode.filter} }>✓</Button>
                                        </td>
                                    </tr>
                                    {#each chosenArchiveNode.filter as filter}
                                        {#if filter.indexOf(filterFilter)!=-1}
                                            <tr>
                                                <td>
                                                    <Input id={`${filter}-filter-id`} type="text" bind:value={filter} style="margin-bottom:1px;"/>
                                                </td>
                                                <td>
                                                    <Button outline color="danger" style="margin-bottom:1px" on:click={()=>{ chosenArchiveNode.filter.splice(chosenArchiveNode.filter.indexOf(filter),1) ;chosenArchiveNode=chosenArchiveNode} }>❌</Button>
                                                </td>
                                            </tr>
                                        {/if}
                                    {/each}
                                </Table>
                            {:else if objectionArchiveNodeShown}
                                <div style="width:100%;height:50px">
                                    <Button outline color="dark" style="float:right;width:120px" on:click={()=>{objectionArchiveNodeShown=false}}>Закрыть</Button>
                                </div>
                                <Table size="sm" borderless>
                                    
                                    {#each objections as obj}
                                        <tr>
                                            <td>
                                                {obj.name}
                                            </td>
                                            <td>
                                                <Input id={`${obj.name}-obj-id`} type="checkbox" style="margin-bottom:1px;" checked={chosenArchiveNode.objection.indexOf(obj.name)!=-1?true:false}  on:change={(e)=>{if(e.target.checked){ chosenArchiveNode.objection.push(obj.name)}else{chosenArchiveNode.objection.splice(chosenArchiveNode.objection.indexOf(obj.name),1)}}}/>
                                            </td>
                                        </tr>
                                    {/each}
                                </Table>
                            {/if}
                            
                        </CardBody>
                    </Card>                                             
                {/if}
        </div>
    {:else if objectionListShown}
        <div style="position:absolute;width:100%;height:calc(100% - 40px);top:40px;margin:10px;overflow:auto;z-index:100">
            {#if chosenObjection}
                <div style="width:600px">
                    <div style="width:100%;height:50px">
                        <Button outline color="dark" style="float:right;width:120px" on:click={()=>{chosenObjection=undefined}}>Закрыть</Button>
                    </div>
                    <Table size="sm" borderless>
                        <tr>
                            <td>
                                <Input type="textarea" bind:value={filterObjectionArea} />
                            </td>
                            <td>
                                <Button outline color="dark" on:click={()=>{ chosenObjection.filter=filterObjectionArea.split('\n');filterObjectionArea=""}}>разобрать</Button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"><Input typoe="text" bind:value={filterObjectionFilter} placeholder="поиск..." /></td>
                        </tr>
                        <tr>
                            <td>
                                <Input type="text" bind:value={newObjectionFilter} />
                            </td>
                            <td>
                                <Button outline color="success" on:click={()=>{ if(newObjectionFilter.trim()!="")chosenObjection.filter.splice(0,0,newObjectionFilter.trim());newObjectionFilter="";chosenObjection.filter=chosenObjection.filter} }>✓</Button>
                            </td>
                        </tr>
                        {#each chosenObjection.filter as filter}
                            {#if filter.indexOf(filterObjectionFilter)!=-1}
                                <tr>
                                    <td>
                                        <Input id={`${filter}-filter-id`} type="text" bind:value={filter} style="margin-bottom:1px;"/>
                                    </td>
                                    <td>
                                        <Button outline color="danger" style="margin-bottom:1px" on:click={()=>{ chosenObjection.filter.splice(chosenObjection.filter.indexOf(filter),1) } }>❌</Button>
                                    </td>
                                </tr>
                            {/if}
                        {/each}
                    </Table>
                </div>
            {:else}
                 <div style="width:100%;height:50px">
                    <Button outline color="dark" style="float:right;width:120px" on:click={()=>{objectionListShown=false;chosenObjection=undefined}}>Закрыть</Button>
                </div>
                <Card style="width:600px;height:210px">
                    <CardBody>
                        <Table size="sm" borderless>
                            <tr>
                                <td>название</td>
                                <td><Input bind:value={newObj.name} /></td>
                            </tr>
                            <tr>
                                <td>фильтр</td>
                                <td><Button outline color="dark" on:click={()=>{chosenObjection=newObj}} >открыть...</Button> </td>
                            </tr>
                             <tr>
                                <td>файл</td>
                                <td><Input type="select" bind:value={newObj.file}>
                                        <option value={undefined}>файл...</option>
                                     {#each files as file}
                                        <option>{file}</option>
                                    {/each}
                                    </Input>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td><Button outline color="success" style="float:right" on:click={()=>{objections.push(newObj);newObj={name:"",filter:[]};objections=objections}}>добавить</Button> </td>
                            </tr>
                        </Table>
                    </CardBody>
                </Card>

                {#each objections as obj}
                    <Card style="width:600px;height:210px">
                        <CardBody>
                            <Table size="sm" borderless>
                                <tr>
                                    <td>название</td>
                                    <td><Input bind:value={obj.name} /></td>
                                </tr>
                                <tr>
                                    <td>фильтр</td>
                                    <td><Button outline color="dark" on:click={()=>{chosenObjection=obj}} >открыть...</Button> </td>
                                </tr>
                                <tr>
                                <td>файл</td>
                                <td><Input type="select" bind:value={obj.file} disabled={true}>
                                        <option value={undefined}>файл...</option>
                                     {#each files as file}
                                        <option>{file}</option>
                                    {/each}
                                    </Input>
                                </td>
                            </tr>
                                <tr>
                                    <td></td>
                                    <td><Button outline color="danger" style="float:right" >удалить</Button> </td>
                                </tr>
                            </Table>
                        </CardBody>
                    </Card>
                {/each}
            {/if}
        </div>
    {:else}
        <svg style="position:absolute;width:100%;height:calc(100% - 40px);top:40px;margin:10px;overflow:auto">
            {#each elems as elem}
                {#if elem.parent!=null}
                    <line x1={`${elem.y*shift +shift/2}`} y1={`${elem.x*shift+elemSize/2}`} x2={`${elem.y*shift-shift/2}`} y2={`${elem.x*shift+elemSize/2}`} style="stroke:rgb(179, 179, 179);stroke-width:2"/>
                    <line x1={`${elem.y*shift-shift/2}`} y1={`${elem.x*shift+elemSize/2}`} x2={`${elem.parent.y*shift +shift/2}`} y2={`${elem.parent.x*shift+elemSize/2}`} style="stroke:rgb(179, 179, 179);stroke-width:2"/>
                {/if}
            {/each}
        </svg>
        <div style="position:absolute;width:100%;height:calc(100% - 40px);top:40px;margin:10px;overflow:auto;z-index:100">
            {#each elems as elem}
                <div class="elem-box" style={`width:${elemSize}px;height:${elemSize}px;top:${elem.x*shift}px;left:${elem.y*shift}px;`} title={elem.name} on:mouseenter={()=>{underMouseElem=elem}} on:click={()=>{chooseElem(elem)}}>
                    {#if elem.type=="start"}
                        <img class="elem-type" src="/img/start.png" alt="start"/>
                    {:else if elem.type=="agree"}
                        <img class="elem-type" src="/img/agree.png" alt="agree" style="background-color:rgb(199, 252, 189)"/>
                    {:else if elem.type=="deny"}
                        <img class="elem-type" src="/img/deny.png" alt="deny" style="background-color:rgb(252, 189, 189)"/>
                    {:else if elem.type=="any"}
                        <img class="elem-type" src="/img/any.png" alt="any" style="background-color:rgb(191, 245, 252)"/>
                    {:else if elem.type=="objection"}
                        <img class="elem-type" src="/img/objection.png" alt="objection" style="background-color:rgb(252, 235, 189)"/>
                     {:else if elem.type=="other"}
                        <img class="elem-type" src="/img/other.png" alt="other" style="background-color:rgb(199, 251, 255);"/>
                    {:else}
                        <img class="elem-type" src="/img/new.png" alt="new" style="background-color:white"/>
                   
                    {/if}
                    {#if elem.action}
                        {#if elem.action=="play"}
                            <img src="/img/play.png" class="elem-action" alt="play" />
                        {:else if elem.action=="hangup"}
                            <img src="/img/hangup.png" class="elem-action" alt="hangup" />
                        {:else if elem.action=="transfer"}
                            <img src="/img/transfer.png" class="elem-action" alt="transfer" />
                        {:else if elem.action=="synthes"}
                            <img src="/img/synthes.png" class="elem-action" alt="synthes" />
                        {:else if elem.action=="ner"}
                            <img src="/img/ner.png" class="elem-action" alt="ner" />
                        
                        {/if}
                    {/if}
                </div>
            {/each}
            {#if underMouseElem}
                {#if underMouseElem.type!="objection"&& underMouseElem.children.length==0}
                    <img class="add-elem" src="/img/add.png" style={`top:${underMouseElem.x*shift+(elemSize-30)/2}px;left:${underMouseElem.y*shift+elemSize+2}px`} alt="add" on:mouseleave={()=>{underMouseElem=undefined}}
                        on:click={()=>{appendChild(underMouseElem)}}/>
                {/if}
                {#if underMouseElem.type!="start"}
                    <img class="add-elem" src="/img/add.png" style={`top:${underMouseElem.x*shift+elemSize+2}px;left:${underMouseElem.y*shift+(elemSize-30)/2}px`} alt="add" on:mouseleave={()=>{underMouseElem=undefined}}
                        on:click={()=>{insertChild(underMouseElem)}}/>
                {/if}
            {/if}
            
        </div>
    
        {#if chosenElem}
            <Card style="width:500px;height:450px;postition:absolute;z-index:104;top:50px;left:50px;overflow:auto">
                <CardBody>
                    {#if !filterShown && !objectionShown}
                        <div style="width:100%;height:50px">
                            {#if chosenElem.type=="new" || chosenElem.type=="" }
                                <div style="float:left;width:250px">
                                    <Input type="select" bind:value={pickFromArchive} style="width:150px;float:left;">
                                        <option value={undefined}></option>
                                        {#each archiveNodes as archNode}
                                            <option value={archNode}>{archNode.name}</option>
                                        {/each}
                                    </Input>
                                    <Button style="width:90px;float:left" color="success" outline on:click={()=>{pickArchive(pickFromArchive)}}>OK</Button>
                                </div>
                            {:else}
                                <Button outline color={chosenElem.archiveNode?"success":"dark"} oultline  style="float:left;width:150px" on:click={()=>{if(!chosenElem.archiveNode){saveAsArchive(chosenElem)}else{updateArchive(chosenElem)}}}>{chosenElem.archiveNode?"✓ в коллекцию":"в коллекцию"}</Button>
                                {#if chosenElem.archiveNode}
                                    <Button outline color="dark" style="float:left;width:150px" on:click={()=>{restoreFromArchive(chosenElem)}}>Восстановить</Button>
                                {/if}
                            {/if}
                            <Button outline color="dark" style="float:right;width:120px" on:click={()=>{chosenElem=undefined}}>Закрыть</Button>
                        </div>
                        <Table size="sm" borderless>
                            <tbody>
                                <tr><td><Label style="float:right;margin-top:6px;margin-bottom:0px">название</Label></td><td><Input type="text" bind:value={chosenElem.name} /></td></tr>
                                <tr>
                                    <td><Label style="float:right;margin-top:6px;margin-bottom:0px">тип варианта</Label></td>
                                    <td>
                                        <Input type="select" bind:value={chosenElem.type} >
                                            <option value=""></option>
                                            <option value="agree">согласие</option>
                                            <option value="deny">отказ</option>
                                            <option value="any">любой</option>
                                            <option value="objection">возражение</option>
                                            <option value="other">другое</option>
                                        </Input>
                                    </td>
                                </tr>
                                {#if chosenElem.type=="agree" || chosenElem.type=="deny"}
                                    <tr>
                                        <td><Label style="float:right;margin-top:6px;margin-bottom:0px">фильтр</Label></td>
                                        <td><Button outline color="dark" on:click={()=>{filterShown=true}} >открыть...</Button></td>
                                    </tr>
                                {/if}
                                {#if chosenElem.type!='objection'}
                                    <tr>
                                        <td><Label style="float:right;margin-top:6px;margin-bottom:0px">действие</Label></td>
                                        <td>
                                            <Input type="select" bind:value={chosenElem.action}>
                                                <option value=""></option>
                                                <option value="play">воспроизвести</option>
                                                <option value="hangup">бросить трубку</option>
                                                <option value="transfer">перевести на номер</option>
                                                <option value="synthes">речь из текста</option>
                                                <option value="ner">распознать информацию</option>
                                            </Input>
                                        </td>
                                    </tr>
                                {/if}
                                {#if chosenElem.action == "ner"}
                                     <tr>
                                        <td><Label style="float:right;margin-top:6px;margin-bottom:0px">тип информации</Label></td>
                                        <td>
                                            <Input type="select" bind:value={chosenElem.nerType}>
                                                <option value="any">любая информация</option>
                                                <option value="address">адрес</option>
                                                <option value="phone">номер телефона</option>
                                                <option value="date">дата</option>
                                                <option value="fio">ФИО</option>
                                            </Input>
                                        </td>
                                    </tr>
                                {/if}
                                {#if chosenElem.action == "synthes"}
                                    <tr>
                                        <td><Label style="float:right;margin-top:6px;margin-bottom:0px">текст</Label></td>
                                        <td>
                                            <Input type="textarea" bind:value={chosenElem.text}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><Label style="float:right;margin-top:6px;margin-bottom:0px">голос</Label></td>
                                        <td>
                                            <Input type="select" bind:value={chosenElem.voice}>
                                                <option value="zahar">Захар</option>
                                                <option value="oksana">Оксана</option>
                                                <option value="jane">Джейн</option>
                                                <option value="omazh">Омаж</option>
                                                <option value="ermil">Ермил</option>
                                            </Input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><Label style="float:right;margin-top:6px;margin-bottom:0px">скорость</Label></td>
                                        <td>
                                            <Input type="number" bind:value={chosenElem.speed}/>
                                        </td>
                                    </tr>
                                {/if}
                                {#if chosenElem.action == "play"}
                                    <tr>
                                        <td><Label style="float:right;margin-top:6px;margin-bottom:0px">файл</Label></td>
                                        <td>
                                            <Input type="select" bind:value={chosenElem.file}>
                                                <option value=""></option>
                                                {#each files as file}
                                                    <option>{file}</option>
                                                {/each}
                                            </Input>
                                        </td>
                                    </tr>
                                {/if}
                                {#if chosenElem.action=="transfer"}
                                    <tr><td><Label style="float:right;margin-top:6px;margin-bottom:0px">номер</Label></td><td><Input type="text" bind:value={chosenElem.number} /></td></tr>
                                {/if}
                                {#if chosenElem.type=="objection" }
                                    <tr>
                                        <td><Label style="float:right;margin-top:6px;margin-bottom:0px">возражения</Label></td>
                                        <td><Button outline color="dark" on:click={()=>{objectionShown=true}} >открыть...</Button></td>
                                    </tr>
                                {/if}
                            </tbody>
                        </Table>
                            <Button outline color="danger"style="position:absolute;bottom:3px;right:3px;" on:click={()=>{removeElementTree(chosenElem);chosenElem=undefined}}>❌ удалить узел</Button>

                    {:else if filterShown}
                        <div style="width:100%;height:50px">
                            <Button outline color="dark" style="float:right;width:120px" on:click={()=>{filterShown=false}}>Закрыть</Button>
                        </div>
                        <Table size="sm" borderless>
                            <tr>
                                <td>
                                    <Input type="textarea" bind:value={filterArea} />
                                </td>
                                <td>
                                    <Button outline color="dark" on:click={()=>{ chosenElem.filter=filterArea.split('\n');filterArea=""}}>разобрать</Button>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2"><Input typoe="text" bind:value={filterFilter} placeholder="поиск..." /></td>
                            </tr>
                            <tr>
                                <td>
                                    <Input type="text" bind:value={newFilter} />
                                </td>
                                <td>
                                    <Button outline color="success" on:click={()=>{ if(newFilter.trim()!="")chosenElem.filter.splice(0,0,newFilter.trim());newFilter="";chosenElem.filter=chosenElem.filter} }>✓</Button>
                                </td>
                            </tr>
                            {#each chosenElem.filter as filter}
                                {#if filter.indexOf(filterFilter)!=-1}
                                    <tr>
                                        <td>
                                            <Input id={`${filter}-filter-id`} type="text" bind:value={filter} style="margin-bottom:1px;"/>
                                        </td>
                                        <td>
                                            <Button outline color="danger" style="margin-bottom:1px" on:click={()=>{ chosenElem.filter.splice(chosenElem.filter.indexOf(filter),1) ;chosenElem=chosenElem} }>❌</Button>
                                        </td>
                                    </tr>
                                {/if}
                            {/each}
                        </Table>
                    {:else if objectionShown}
                        <div style="width:100%;height:50px">
                            <Button outline color="dark" style="float:right;width:120px" on:click={()=>{objectionShown=false}}>Закрыть</Button>
                        </div>
                        <Table size="sm" borderless>
                            
                            {#each objections as obj}
                                <tr>
                                    <td>
                                        {obj.name}
                                    </td>
                                    <td>
                                        <Input id={`${obj.name}-obj-id`} type="checkbox" style="margin-bottom:1px;" checked={chosenElem.objection.indexOf(obj.name)!=-1?true:false}  on:change={(e)=>{if(e.target.checked){ chosenElem.objection.push(obj.name)}else{chosenElem.objection.splice(chosenElem.objection.indexOf(obj.name),1)}}}/>
                                    </td>
                                </tr>
                            {/each}
                        </Table>
                    {/if}
                    
                </CardBody>
            </Card>
        {/if}
    {/if}
</div>


